import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const PAS = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12708"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12708)">
          <rect
            x="-33.4546"
            y="-2"
            width="197.706"
            height="114"
            rx="6.37762"
            fill="#F4F4F4"
          />
          <rect
            x="31.7168"
            y="21.7166"
            width="49.028"
            height="66.4525"
            rx="3.502"
            fill="white"
            stroke="#191919"
            strokeWidth="1.1958"
          />
          <path
            d="M77.3068 22.1437L32.1438 84.4622C32.1438 84.4622 32.461 86.1663 33.0257 86.7814C33.5903 87.3965 34.3561 87.7421 35.1547 87.7421H77.3068C78.1053 87.7421 78.8711 87.3965 79.4358 86.7814C80.0004 86.1663 80.3176 85.3321 80.3176 84.4622V25.4236C80.3176 24.5537 80.0004 23.7194 79.4358 23.1043C78.8711 22.4892 77.3068 22.1437 77.3068 22.1437Z"
            fill="#E3E3E3"
          />
          <path
            d="M42.3938 36.4933H62.8149"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 42.6432H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 48.7931H62.8149"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 54.9427H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 61.0927H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 67.2426H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 73.3928H62.8149"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="31.7168"
            y="21.7166"
            width="49.028"
            height="66.4525"
            rx="3.502"
            stroke="#191919"
            strokeWidth="1.1958"
          />
          <path
            d="M97.6088 57.4826L95.6912 59.4002L89.2993 53.0083L91.2169 51.0907C92.0691 50.2657 93.2115 49.8088 94.3976 49.8184C95.5838 49.828 96.7186 50.3035 97.5573 51.1422C98.3961 51.981 98.8715 53.1158 98.8811 54.3019C98.8908 55.488 98.4338 56.6304 97.6088 57.4826Z"
            fill="#FF808C"
          />
          <path
            d="M82.3193 72.7719L73.3706 75.3287L75.9274 66.38L82.3193 72.7719Z"
            fill="#FFBC44"
          />
          <path
            d="M89.2991 53.0109L75.9272 66.3828L82.3191 72.7747L95.691 59.4028L89.2991 53.0109Z"
            fill="#FFEF5E"
          />
          <path
            d="M97.6088 57.4826L95.6912 59.4002L89.2993 53.0083L91.2169 51.0907C92.0691 50.2657 93.2115 49.8088 94.3976 49.8184C95.5838 49.828 96.7186 50.3035 97.5573 51.1422C98.3961 51.981 98.8715 53.1158 98.8811 54.3019C98.8908 55.488 98.4338 56.6304 97.6088 57.4826Z"
            stroke="#191919"
            strokeWidth="1.1958"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.3193 72.7719L73.3706 75.3287L75.9274 66.38L82.3193 72.7719Z"
            stroke="#191919"
            strokeWidth="1.1958"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.2991 53.0109L75.9272 66.3828L82.3191 72.7747L95.691 59.4028L89.2991 53.0109Z"
            stroke="#191919"
            strokeWidth="1.1958"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.8207 12.1191H89.7614V10.8203H91.8207C92.1389 10.8203 92.3979 10.7685 92.5977 10.6649C92.7976 10.5575 92.9437 10.4095 93.0363 10.2208C93.1288 10.0321 93.175 9.81931 93.175 9.58248C93.175 9.34195 93.1288 9.11807 93.0363 8.91085C92.9437 8.70362 92.7976 8.5371 92.5977 8.41129C92.3979 8.28547 92.1389 8.22257 91.8207 8.22257H90.3386V14.9999H88.6734V6.91816H91.8207C92.4534 6.91816 92.9955 7.03287 93.447 7.2623C93.9022 7.48803 94.25 7.80071 94.4905 8.20036C94.7311 8.60001 94.8513 9.05702 94.8513 9.57138C94.8513 10.0931 94.7311 10.5446 94.4905 10.9257C94.25 11.3069 93.9022 11.6011 93.447 11.8083C92.9955 12.0155 92.4534 12.1191 91.8207 12.1191ZM98.3649 8.30028L96.1668 14.9999H94.3962L97.3991 6.91816H98.5259L98.3649 8.30028ZM100.191 14.9999L97.9875 8.30028L97.8098 6.91816H98.9477L101.967 14.9999H100.191ZM100.091 11.9915V13.2959H95.8227V11.9915H100.091ZM106.924 12.8851C106.924 12.7408 106.902 12.6113 106.857 12.4966C106.817 12.3782 106.739 12.2709 106.624 12.1746C106.51 12.0747 106.349 11.9767 106.141 11.8805C105.934 11.7842 105.666 11.6843 105.337 11.5807C104.97 11.4623 104.622 11.3291 104.293 11.1811C103.967 11.0331 103.679 10.861 103.427 10.6649C103.179 10.465 102.983 10.2338 102.839 9.97103C102.698 9.7083 102.628 9.40301 102.628 9.05517C102.628 8.71843 102.702 8.41314 102.85 8.13931C102.998 7.86177 103.205 7.62494 103.472 7.42882C103.738 7.229 104.052 7.07543 104.415 6.96811C104.781 6.8608 105.183 6.80714 105.62 6.80714C106.215 6.80714 106.735 6.91446 107.179 7.12908C107.623 7.34371 107.968 7.63789 108.212 8.01164C108.46 8.38539 108.584 8.81279 108.584 9.29385H106.93C106.93 9.05702 106.88 8.84979 106.78 8.67217C106.684 8.49085 106.535 8.34838 106.336 8.24477C106.14 8.14116 105.892 8.08935 105.592 8.08935C105.303 8.08935 105.063 8.13376 104.87 8.22257C104.678 8.30768 104.534 8.42424 104.437 8.57226C104.341 8.71658 104.293 8.8794 104.293 9.06072C104.293 9.19763 104.326 9.3216 104.393 9.43261C104.463 9.54363 104.567 9.64724 104.704 9.74345C104.841 9.83966 105.009 9.93032 105.209 10.0154C105.409 10.1005 105.64 10.1838 105.903 10.2652C106.343 10.3984 106.73 10.5483 107.063 10.7148C107.4 10.8813 107.681 11.0682 107.907 11.2754C108.132 11.4827 108.302 11.7176 108.417 11.9804C108.532 12.2431 108.589 12.541 108.589 12.874C108.589 13.2256 108.521 13.5401 108.384 13.8176C108.247 14.0952 108.049 14.3302 107.79 14.5226C107.531 14.715 107.222 14.8612 106.863 14.9611C106.504 15.061 106.103 15.111 105.658 15.111C105.259 15.111 104.865 15.0591 104.476 14.9555C104.088 14.8482 103.734 14.6873 103.416 14.4726C103.101 14.258 102.85 13.9842 102.661 13.6511C102.472 13.3181 102.378 12.924 102.378 12.4688H104.049C104.049 12.7205 104.088 12.9332 104.165 13.1072C104.243 13.2811 104.352 13.4217 104.493 13.529C104.637 13.6363 104.807 13.714 105.004 13.7621C105.203 13.8102 105.422 13.8343 105.658 13.8343C105.947 13.8343 106.184 13.7936 106.369 13.7122C106.558 13.6308 106.696 13.5179 106.785 13.3736C106.878 13.2293 106.924 13.0665 106.924 12.8851Z"
            fill="#626266"
          />
        </g>
      </SvgIcon>
    );
  })
);
PAS.displayName = 'PAS';
